import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { MissionContext } from "../contexts/MissionTasksContext";
import TasksTable from "./TasksTable";
import { USER_ROLES } from "constants";
import { MOVEMENTS_STATUS, tasks_status } from "modules/pvs_activities/constants";
import ReportModal from "./ReportModal";

const MissionTasks = ({ showCountry, taskTableFilterConfigurations, config, showReportBugButton }) => {

  const { t } = useTranslation();
  const authData = useSelector(s => s.auth.data);
  const missionContext = useContext(MissionContext);
  const [allTasks, setAllTasks] = useState(missionContext.movements)
  const [completedTasks, setCompletedTasks] = useState([]);
  const [pendingTasks, setPendingTasks] = useState([]);
  const [unavailableTasks, setUnavailableTasks] = useState([]);
  const [delegatesTasks, setDelegatesTasks] = useState([]);
  const [expertTasks, setExpertTasks] = useState([]);
  const [skippedTasks, setSkippedTasks] = useState([]);
  const [myTasks, setMyTasks] = useState([]);
  const [tab, setTab] = useState('my-tasks');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tabsConfig, setTabConfig] = useState({
    showAllTasks: true,
    showMyTasks: true,
    showPendingTasks: true,
    showCompletedTasks: true,
    showUnavailableTasks: true,
    showDelegateTasks: true,
    showExpertTasks: true,
    showSkipTasks: true,
    ...config,
  })
  const isDelegateUser = (role_id = null) => {
    return USER_ROLES.delegate.includes(role_id);
  };
  const isExpertUser = (role_id = null) => {
    return USER_ROLES.experts.includes(role_id);
  };
  const isBusinessAdmin = () => {
    return USER_ROLES.business_admin.includes(parseInt(authData?.role_id));
  };
  const isItAdmin = () => {
    return USER_ROLES.it_admin.includes(parseInt(authData?.role_id));
  };
  const isCBDStaff = () => {
    return USER_ROLES.cbd_staff.includes(parseInt(authData?.role_id));
  }

  const isMissionManager = () => {
    return parseInt(authData?.id) === parseInt(missionContext.missionManager);
  };

  const handleTasks = async () => {
    if (isBusinessAdmin() || isItAdmin() || isCBDStaff() || isMissionManager()) {
      setMyTasks(
        taskTableFilterConfigurations.value === 1 ?
          missionContext.movements?.filter(d =>
            d.status !== MOVEMENTS_STATUS.completed &&
            d.is_enabled &&
            d.status !== MOVEMENTS_STATUS.skip &&
            parseInt(d.user_id) === parseInt(authData?.id) && d.d_form_id && d.relationForm?.mission_phase_id === 344
          ) :
          taskTableFilterConfigurations.value === 0 ?
            missionContext.movements?.filter(d =>
              d.status !== MOVEMENTS_STATUS.completed &&
              d.is_enabled &&
              d.status !== MOVEMENTS_STATUS.skip &&
              parseInt(d.user_id) === parseInt(authData?.id) &&
              d.d_form_id && d.relationForm?.mission_phase_id !== 344
            )
            :
            missionContext.movements?.filter(d =>
              d.status !== MOVEMENTS_STATUS.completed &&
              d.is_enabled &&
              d.status !== MOVEMENTS_STATUS.skip &&
              parseInt(d.user_id) === parseInt(authData?.id)
            )
      );
      setPendingTasks(
        taskTableFilterConfigurations.value === 1 ?
          missionContext.movements?.filter(d =>
            d.status !== MOVEMENTS_STATUS.completed &&
            d.is_enabled &&
            d.status !== MOVEMENTS_STATUS.skip &&
            d.d_form_id && d.relationForm?.mission_phase_id === 344
          ) :
          taskTableFilterConfigurations.value === 0 ?
            missionContext.movements?.filter(d =>
              d.status !== MOVEMENTS_STATUS.completed &&
              d.is_enabled &&
              d.status !== MOVEMENTS_STATUS.skip &&
              d.d_form_id && d.relationForm?.mission_phase_id !== 344
            ) :
            missionContext.movements?.filter(d =>
              d.status !== MOVEMENTS_STATUS.completed &&
              d.is_enabled &&
              d.status !== MOVEMENTS_STATUS.skip)
      );
      setCompletedTasks(
        taskTableFilterConfigurations.value === 0 ?
          missionContext.movements?.filter(d =>
            d.status === MOVEMENTS_STATUS.completed &&
            d.d_form_id && d.relationForm?.mission_phase_id !== 344)
          :
          taskTableFilterConfigurations.value === 1 ?
            missionContext.movements?.filter(d =>
              d.status === MOVEMENTS_STATUS.completed &&
              d.d_form_id && d.relationForm?.mission_phase_id === 344)
            : missionContext.movements?.filter(d =>
              d.status === MOVEMENTS_STATUS.completed)
      );
      setDelegatesTasks(
        taskTableFilterConfigurations.value === 1 ?
          missionContext.movements?.filter(d =>
            d.status !== MOVEMENTS_STATUS.completed &&
            isDelegateUser(d?.relationUser?.role_id) && d.d_form_id && d.relationForm?.mission_phase_id === 344) :
          taskTableFilterConfigurations.value === 0 ?
            missionContext.movements?.filter(d =>
              d.status !== MOVEMENTS_STATUS.completed &&
              isDelegateUser(d?.relationUser?.role_id) && d.d_form_id && d.relationForm?.mission_phase_id !== 344) :
            missionContext.movements?.filter(d =>
              d.status !== MOVEMENTS_STATUS.completed &&
              isDelegateUser(d?.relationUser?.role_id))
      );
      setExpertTasks(
        taskTableFilterConfigurations.value === 1 ?
          missionContext.movements?.filter(d =>
            ![MOVEMENTS_STATUS.completed, MOVEMENTS_STATUS.skip].includes(d.status) &&
            isExpertUser(d?.relationUser?.role_id) && d.d_form_id && d.relationForm?.mission_phase_id === 344)
          : taskTableFilterConfigurations.value === 0 ?
            missionContext.movements?.filter(d =>
              ![MOVEMENTS_STATUS.completed, MOVEMENTS_STATUS.skip].includes(d.status) &&
              isExpertUser(d?.relationUser?.role_id) && d.d_form_id && d.relationForm?.mission_phase_id !== 344)
            : missionContext.movements?.filter(d =>
              ![MOVEMENTS_STATUS.completed, MOVEMENTS_STATUS.skip].includes(d.status) &&
              isExpertUser(d?.relationUser?.role_id))
      );
      setUnavailableTasks(
        taskTableFilterConfigurations.value === 1 ?
          missionContext.movements?.filter(d =>
            d.status === MOVEMENTS_STATUS.pending &&
            !d.is_enabled && d.d_form_id && d.relationForm?.mission_phase_id === 344)
          : taskTableFilterConfigurations.value === 0 ?
            missionContext.movements?.filter(d =>
              d.status === MOVEMENTS_STATUS.pending &&
              !d.is_enabled && d.d_form_id && d.relationForm?.mission_phase_id !== 344)
            :
            missionContext.movements?.filter(d =>
              d.status === MOVEMENTS_STATUS.pending &&
              !d.is_enabled)
      );
      setAllTasks(
        taskTableFilterConfigurations.value === 0 ?
          missionContext.movements?.filter(d =>
            d.d_form_id && d.relationForm?.mission_phase_id !== 344
          ) :
          taskTableFilterConfigurations.value === 1 ?
            missionContext.movements?.filter(d =>
              d.d_form_id && d.relationForm?.mission_phase_id === 344
            )
            :
            missionContext.movements
      );
      setSkippedTasks(
        taskTableFilterConfigurations.value === 1 ?
          missionContext.movements?.filter(d =>
            d.status === MOVEMENTS_STATUS.skip && d.relationForm?.mission_phase_id === 344
          ) : taskTableFilterConfigurations.value === 0 ?
            missionContext.movements?.filter(d =>
              d.status === MOVEMENTS_STATUS.skip && d.relationForm?.mission_phase_id !== 344
            ) : missionContext.movements?.filter(d =>
              d.status === MOVEMENTS_STATUS.skip
            )
      );
    } else {
      setCompletedTasks(
        taskTableFilterConfigurations.value === 1 ?
          missionContext.movements?.filter(d =>
            d.status === MOVEMENTS_STATUS.completed &&
            (d.d_form_id !== null || (d.d_form_id && d.relationForm?.mission_phase_id === 344))
          ) :
          taskTableFilterConfigurations.value === 0 ?
            missionContext.movements?.filter(d =>
              d.status === MOVEMENTS_STATUS.completed &&
              (d.d_form_id !== null || (d.d_form_id && d.relationForm?.mission_phase_id !== 344))
            ) :
            missionContext.movements?.filter(d =>
              d.status === MOVEMENTS_STATUS.completed)
      );
      setPendingTasks(
        taskTableFilterConfigurations.value === 1 ?
          missionContext.movements?.filter(d =>
            d.status !== MOVEMENTS_STATUS.completed &&
            (d.d_form_id !== null || (d.d_form_id && d.relationForm?.mission_phase_id === 344))
          ) :
          taskTableFilterConfigurations.value === 0 ?
            missionContext.movements?.filter(d =>
              d.status !== MOVEMENTS_STATUS.completed &&
              (d.d_form_id !== null || (d.d_form_id && d.relationForm?.mission_phase_id !== 344))
            ) :
            missionContext.movements?.filter(d =>
              d.status !== MOVEMENTS_STATUS.completed
            )
      );
    }
  };

  const handleConfiguration = () => {
    if (!(isBusinessAdmin() || isCBDStaff() || isMissionManager())) {
      if ((isItAdmin())) {
        setTab("all-tasks");
        setTabConfig({
          ...tabsConfig,
          showMyTasks: true,
        })
      }
      else {
        setTab("pending");
        setTabConfig({
          ...tabsConfig,
          showAllTasks: false,
          showDelegateTasks: false,
          showMyTasks: false,
          showUnavailableTasks: false,
          showExpertTasks: false,
          showSkipTasks: false,
        })
      }
    }
  }

  useEffect(() => {
    handleConfiguration();
  }, []);

  useEffect(() => {
    handleTasks();
  }, [missionContext.movements]);

  const taskTabs = () => {
    return (
      <div className="d-flex justify-content-between">
        <ul className="nav nav-tabs mb-2">
          {
            tabsConfig.showAllTasks && (
              <li className="nav-item">
                <a
                  className={`nav-link ${tab == 'all-tasks' ? 'active' : ''}`}
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    setTab('all-tasks');
                  }}
                >
                  {t("-1", "All Tasks")}
                </a>
              </li>
            )
          }
          {
            tabsConfig.showMyTasks && (
              <li className="nav-item">
                <a
                  className={`nav-link ${tab == 'my-tasks' ? 'active' : ''}`}
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    setTab('my-tasks');
                  }}
                >
                  {t("-1", "My Tasks")}
                </a>
              </li>
            )
          }
          {
            tabsConfig.showPendingTasks && (
              <li className="nav-item">
                <a
                  className={`nav-link ${tab == 'pending' ? 'active' : ''}`}
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    setTab('pending');
                  }}
                >
                  {t("-1", "Pending Tasks")}
                </a>
              </li>
            )
          }
          {
            tabsConfig.showDelegateTasks && (
              <li className="nav-item">
                <a
                  className={`nav-link ${tab == 'delegate-tasks' ? 'active' : ''}`}
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    setTab('delegate-tasks');
                  }}
                >
                  {t("-1", " Delegate Tasks")}
                </a>
              </li>
            )
          }
          {
            tabsConfig.showExpertTasks && (
              <li className="nav-item">
                <a
                  className={`nav-link ${tab == 'expert-tasks' ? 'active' : ''}`}
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    setTab('expert-tasks');
                  }}
                >
                  {t("-1", " Expert Tasks")}
                </a>
              </li>
            )
          }
          {/* This tab is commented on the base of ticket 1131 */}
          {/* {
          tabsConfig.showUnavailableTasks && (
            <li className="nav-item">
              <a
                className={`nav-link ${tab == 'unavailable-tasks' ? 'active' : ''}`}
                href="#"
                onClick={e => {
                  e.preventDefault();
                  setTab('unavailable-tasks');
                }}
              >
                {t("-1", "Unavailable Tasks")}
              </a>
            </li>
          )
        } */}
          {
            tabsConfig.showCompletedTasks && (
              <li className="nav-item">
                <a
                  className={`nav-link ${tab == 'completed' ? 'active' : ''}`}
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    setTab('completed');
                  }}
                >
                  {t("-1", "Completed Tasks")}
                </a>
              </li>
            )
          }
          {
            tabsConfig.showSkipTasks && (
              <li className="nav-item">
                <a
                  className={`nav-link ${tab == 'skipped' ? 'active' : ''}`}
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    setTab('skipped');
                  }}
                >
                  {t("-1", "Skipped Tasks")}
                </a>
              </li>
            )
          }
        </ul>
        {!missionContext.is_archived && showReportBugButton && <button className="btn fs-7 lh-1 ms-2 btn-dark" onClick={() => setIsModalVisible(true)} >
          Report A Bug
        </button>}
      </div>
    );
  };

  return (
    <>
      <div className="card card-woah border border-secondary shadow rounded-0 mt-0">
        <div className="card-body p-4">
          {
            tab === 'all-tasks' && (
              <TasksTable
                cardHeader={"All Tasks"}
                movements={allTasks}
                showCountry={showCountry}
                isCompleted={tasks_status.all}
                filtersConfig={taskTableFilterConfigurations}
                isMissionManager={isMissionManager()}
              >
                {taskTabs()}
              </TasksTable>
            )
          }
          {
            tab === 'completed' && (
              <TasksTable
                cardHeader={"Completed Tasks"}
                movements={completedTasks}
                showCountry={showCountry}
                isCompleted={tasks_status.completed}
                filtersConfig={taskTableFilterConfigurations}
                isMissionManager={isMissionManager()}
              >
                {taskTabs()}
              </TasksTable>
            )
          }
          {
            tab === 'pending' && (
              <TasksTable
                cardHeader={"Pending Tasks"}
                movements={pendingTasks}
                showCountry={showCountry}
                isCompleted={tasks_status.pending}
                filtersConfig={taskTableFilterConfigurations}
                isMissionManager={isMissionManager()}
              >
                {taskTabs()}
              </TasksTable>
            )
          }
          {
            tab === 'delegate-tasks' && (
              <TasksTable
                cardHeader={"Delegate Tasks"}
                movements={delegatesTasks}
                showCountry={showCountry}
                isCompleted={tasks_status.pending}
                filtersConfig={taskTableFilterConfigurations}
                isMissionManager={isMissionManager()}
              >
                {taskTabs()}
              </TasksTable>
            )
          }
          {
            tab === 'expert-tasks' && (
              <TasksTable
                cardHeader={"Expert Tasks"}
                movements={expertTasks}
                showCountry={showCountry}
                isCompleted={tasks_status.pending}
                filtersConfig={taskTableFilterConfigurations}
                isMissionManager={isMissionManager()}
              >
                {taskTabs()}
              </TasksTable>
            )
          }
          {
            tab === 'my-tasks' && (
              <TasksTable
                cardHeader={"My Tasks"}
                movements={myTasks}
                showCountry={showCountry}
                isCompleted={tasks_status.pending}
                filtersConfig={taskTableFilterConfigurations}
                isMissionManager={isMissionManager()}
              >
                {taskTabs()}
              </TasksTable>
            )
          }
          {
            tab === 'unavailable-tasks' && (
              <TasksTable
                cardHeader={"Unavailable Tasks"}
                movements={unavailableTasks}
                showCountry={showCountry}
                isCompleted={tasks_status.pending}
                filtersConfig={taskTableFilterConfigurations}
                isMissionManager={isMissionManager()}
              >
                {taskTabs()}
              </TasksTable>
            )
          }
          {
            tab === 'skipped' && (
              <TasksTable
                cardHeader={"Skipped Tasks"}
                movements={skippedTasks}
                showCountry={showCountry}
                isCompleted={tasks_status.pending}
                filtersConfig={taskTableFilterConfigurations}
                isMissionManager={isMissionManager()}
              >
                {taskTabs()}
              </TasksTable>
            )
          }
        </div>
      </div>
      <ReportModal
        isShow={isModalVisible}
        initModal={() => setIsModalVisible(false)}
        missionId={missionContext?.missionData?.id}
      />
    </>
  );
};

MissionTasks.defaultProps = {
  showCountry: false,
  showReportBugButton: false,
  config: {
    showAllTasks: true,
    showMyTasks: true,
    showPendingTasks: true,
    showCompletedTasks: true,
    showUnavailableTasks: true,
    showDelegateTasks: true,
    showExpertTasks: true,
    showSkipTasks: true,
    is_report_shown: false
  },
  taskTableFilterConfigurations: {
    showCountry: false,
    showMissionType: false,
    showMissionPhase: true,
    showDueDate: true,
    showStatus: true,
    showPersonAssigned: true,
    is_report_shown: false,
    value: 3
  }
};

export default MissionTasks;